import { cva } from 'class-variance-authority';
import { fontBase, inlineCenter } from '@/lib/styleUtils';

export const avatarVariants = cva(
  // Base classes for all avatars
  [
    fontBase,
    inlineCenter,
    'tw:relative tw:flex-shrink-0',
    'tw:rounded-full',
    'tw:font-bold tw:uppercase',
  ].join(' '),
  {
    variants: {
      variant: {
        primary: 'tw:bg-primary tw:text-white',
        secondary: 'tw:bg-gray-lighter tw:text-gray-darker',
        colorFromName: '',
        // Background/foreground are set inline, derived from AVATAR_ACCENT.
        accent: '',
      },
      size: {
        small: 'tw:w-8 tw:h-8 tw:text-14',
        medium: 'tw:w-10 tw:h-10 tw:text-14',
        large: 'tw:w-12 tw:h-12 tw:text-16',
      },
      isOutline: {
        true: 'tw:outline tw:outline-2 tw:outline-[#FFFFFF]',
        false: '',
      },
    },
    compoundVariants: [],
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
      isOutline: false,
    },
  }
);

export const avatarContainerClasses = 'tw:relative tw:inline-flex';

export const statusContainerClasses = 'tw:absolute tw:bottom-0 tw:right-0 tw:z-10';

export const statusOffsetClasses = '[transform:translate(33%,33%)]';

export const avatarImageClasses = 'tw:w-full tw:h-full tw:object-cover';

export const avatarIconClasses = 'tw:flex tw:items-center tw:justify-center';

export const iconSizeClasses: Record<string, string> = {
  small: 'tw:[&>svg]:w-4 tw:[&>svg]:h-4',
  medium: 'tw:[&>svg]:w-6 tw:[&>svg]:h-6',
  large: 'tw:[&>svg]:w-8 tw:[&>svg]:h-8',
};
